<template>
  <v-container grid-list-xs>
    <v-row class="justify-center">
      <v-col cols="6">
        <v-card>
          <v-card-title primary-title>
            Cash Transfer
            <v-spacer></v-spacer>
            <v-btn @click="OnNewAccount" icon color="primary">
              <v-icon>fas fa-plus</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="">
            <v-form v-model="valid" ref="paymentForm">
              <BaseDate
                v-model="PayDate"
                outlined
                :rules="v => !!v || 'Date is required'"
              >
              </BaseDate>

              <v-autocomplete
                @change="CheckBalance"
                :success-messages="AccountBlce > 0 ? Balance : ''"
                :error-messages="
                  AccountBlce <= 0 && Transfer.FromAcc && !searching
                    ? Balance
                    : ''
                "
                outlined
                :loading="searching"
                v-model.trim="Transfer.FromAcc"
                :rules="[v => !!v || 'Cash Account is required']"
                :items="Cashes"
                item-text="AccountName"
                item-value="_id"
                label="Transfer From"
                prepend-inner-icon="fas fa-random"
                required
                no-data-text="No Cash Account"
              ></v-autocomplete>

              <BaseNumInput
                :rules="[paymentRule]"
                outlined
                v-model.trim="Amount"
                label="Transer Amount"
              ></BaseNumInput>

              <v-autocomplete
                outlined
                :loading="searching"
                v-model.trim="Transfer.ToAcc"
                :rules="[
                  v => (!!v && v != Transfer.FromAcc) || 'Invalid Account',
                ]"
                :items="Cashes"
                item-text="AccountName"
                item-value="_id"
                label="Transfer To"
                prepend-inner-icon="fas fa-hand-holding-usd"
                required
                no-data-text="No Cash Account"
              ></v-autocomplete>

              <v-text-field
                name="InfoFildName"
                label="Info"
                id="InfoFildid"
                outlined
                v-model.trim="Details"
                :rules="[v => !!v || 'Provide Infomation']"
              ></v-text-field>
            </v-form>
            <p
              v-if="ErrMsg"
              v-html="ErrMsg"
              class="text-center error--text"
            ></p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              width="200px"
              :loading="loading"
              @click="OnSavePayment"
              :disabled="!valid"
              color="success"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <NewBankAccount
      :loadFunction="OpenPayment"
      :AccountType="3"
      title="New Bank Account"
      @OnClosed="NewAccount = false"
      :OpenNewExpense="NewAccount"
    >
    </NewBankAccount>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {
    NewBankAccount: () => import("@/components/util/NewAccount.vue"),
  },
  data() {
    return {
      BaseURL: "/Reports/cash/transfer",
      ErrMsg: "",
      loading: false,
      searching: false,
      dialog: false,
      valid: false,
      NewAccount: false,
      AccountBlce: 0,
      TransferInfo: {},
      Transfer: { FromAcc: null, ToAcc: null },
      Cashes: [],
      PayDate: "",
      Amount: 0,
      Details: "",
    };
  },

  computed: {
    ...mapGetters(["UsersToken"]),
    Balance() {
      return `${this.AccountBlce.toLocaleString()} ${this.UsersToken.CashBase}`;
    },
  },
  methods: {
    OnNewAccount() {
      this.NewAccount = true;
    },
    SameAccount(val) {
      if (!val) return "This is Required";
      else if (this.Transfer.FromAccount === this.Transfer.ToAccount)
        return "Accounts must be defferent";
      else return true;
    },
    close() {
      this.ErrMsg = "";
      this.Transfer.ToAcc = null;
      this.Transfer.FromAcc = null;
      this.PayDate = "";
      this.Details = "";
      this.Amount = 0;
      this.AccountBlce = 0;
      this.$refs.paymentForm.resetValidation();
    },
    CheckBalance(selected) {
      this.searching = true;
      this.AccountBlce = 0;
      this.GetReq("/Account/checkBalance", { Account: selected })
        .then(({ data }) => {
          if (data.length) this.AccountBlce = data[0].Amount;
          // console.log(val);
          this.searching = false;
          if (this.valid) this.$refs.paymentForm.validate();
        })
        .catch(err => {
          console.log(err);
          this.searching = false;
        });
    },
    GetReq(url, query) {
      if (!url) url = "/Account";
      if (!query) query = { acc: [{ AccountType: 1 }, { AccountType: 3 }] };

      return this.$store.dispatch("FIND_BY_VALUE", {
        url,
        query,
      });
    },
    OpenPayment() {
      this.searching = true;
      this.GetReq()
        .then(cash => {
          this.searching = false;
          this.Cashes = cash.data;
          this.$nextTick(() => {
            this.PayDate = this.Current().date;
          });
        })
        .catch(err => {
          console.log(err);
          this.searching = false;
        });
    },
    OnSavePayment() {
      this.ErrMsg = "";
      if (this.$refs.paymentForm.validate()) {
        let data = {
          fromAccount: this.Transfer.FromAcc,
          toAccount: this.Transfer.ToAcc,
          Amount: this.Amount,
          Details: this.Details,
          date: this.PayDate,
          time: this.Current().time,
        };
        this.loading = true;
        this.$store
          .dispatch("INSERT_ONLY", { url: this.BaseURL, data })
          .then(() => {
            // console.log(val);

            this.loading = false;

            this.close();
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
            this.ErrMsg = error && error.response && error.response.data;
          });
      }
    },
    paymentRule(v) {
      //   v = v.replace(/,/g, "");
      let andCon =
        v && v.replace(/,/g, "") > 0 && v.replace(/,/g, "") <= this.AccountBlce;
      return andCon || "Invalid Amount";
    },
  },
  created() {
    this.OpenPayment();
  },
};
</script>
